import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=06954052&scoped=true&"
import script from "./Setting.js?vue&type=script&lang=js&"
export * from "./Setting.js?vue&type=script&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=06954052&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06954052",
  null
  
)

export default component.exports